<footer>
  <div class="footer-content">
    <p class="copyrightMsg">&copy; {{ currentYear }} FinanceLogic LLC. All Rights Reserved.</p>
    <div class="socialLinks mb-3">
      <a [href]="item.link" *ngFor="let item of socialLinksList" target="_blank" rel="noopener noreferrer">
        <span [innerHTML]="item.linkIcon"></span>
      </a>
    </div>
  </div>
</footer>